import React, {useEffect} from "react";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchTagList} from "../../store/list-slice";
import {Status} from "../../enums/enums";
import {incomeProductSchema} from "../../schema/incomeProductSchema";
import {getFormData} from "../../models/incomeProductModel";
import Form from "../../components/common/form/Form";
import {capitalize} from "../../components/Utility";
import {createIncomeProduct} from "../../store/income-product-slice";

const IncomeProductAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const incomeType = params.incomeType;

    const {createStatus, error} = useSelector(state => state.incomeProduct);
    const userRole = useSelector((state) => state.auth.selectedRole);

    const {
        items,
    } = useSelector(state => state.menu.transactionType);

    const incomeTypeId = items.find(
        (item) => item.name.toLowerCase() === incomeType.toLowerCase()
    )?._id;

    const list = useSelector(state => state.list);

    useEffect(() => {
        if (createStatus === "success") {
            navigator("..");
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            ttid: incomeTypeId
        }
        dispatch(createIncomeProduct({data: updatedData}));
    };

    const formCancelHandler = () => {
        navigator("..");
    };

    useEffect(() => {
        dispatch(fetchTagList(userRole));
    }, [dispatch, userRole]);

    // Create a mutable copy of Status
    const updatedStatus = {...Status};
    delete updatedStatus.Archived;

    const schema = incomeProductSchema({list, Status: updatedStatus});
    delete schema.availability
    const initialData = getFormData();

    return (
        <>
            <SubHeader title={`Add ${capitalize(params.incomeType)} Product`}>
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-6">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default IncomeProductAdd;
